import styled from 'styled-components';
import { ShadowBoxDark } from 'app/components';
import { AsideEntityDetails } from 'app/components/Entity';

export const AsideCinemaDetails = styled(AsideEntityDetails).attrs({
  className: 's-cinema__details-aside'
})`
  .s-cinema-details__aside-img {
    width: 100%;
  }
  .text-inline a{
    color:#DE1619;
    text-decoration: underline;
  }
`;

export const SessionsList = styled.ul.attrs({
  className: 'l-sessions'
})``;

export const SessionsListItem = styled(ShadowBoxDark).attrs({
  className: 'l-sessions__item'
})`
  width: 100%;
  padding: 16px 18px 18px;

  & + & {
    margin-top: ${({ theme }) => theme.indent.l};
  }
`;

export const BlockCinemaMap = styled.div`
  height: 360px;
  margin-top: ${({ theme }) => theme.indent.xxl};
  position: relative;

  .b-cinema__map-info {
    max-width: 200px;

    & > h5 {
      font-size: 1.6rem;
      font-weight: 500;
      color: ${({ theme }) => theme.color.bgPrimary};
    }

    & > p {
      margin-top: ${({ theme }) => theme.indent.s};
      font-size: 1.2rem;
      color: ${({ theme }) => theme.color.labelColor};
    }
  }

  @media screen and (max-width: ${({ theme }) => theme.breakPoints.sm.width}) {
    margin-top: ${({ theme }) => theme.indent.xl};
  }
`;
